export default {
  data() {
    return {
      /*
        publicConfig is defined in /public/config/config.js
        which is loaded in index.html <head>
       */
      // eslint-disable-next-line
      calc_cta: publicConfig.public_calc_cta,
      // eslint-disable-next-line
      typ_grejanje_cena_data_cfg: JSON.parse(publicConfig.public_heating_prices_str),
    };
  },
  methods: {
    uppercase: function (param) {
      return param.toLocaleUpperCase(this.getlocale());
    },
    capitalize: function (param) {
      const left = param.substr(0, 1);
      return left.toLocaleUpperCase(this.getlocale()) + param.substr(1);
    },
    getlocale: function () {
      const lang = this.app_language ? this.app_language.value : this.$root.$children[0].data.app_language.value;
      return this.app_locales ? this.app_locales[lang] : this.$root.$children[0].locales[lang];
    },
  },
};
